import { Magic } from 'magic-sdk'

import { MAGIC_STAGE_API, MAGIC_PROD_API } from '../../constants/apis'
import { Environment } from '../n3xus/types'

interface MagicConfig {
    network?: {
        rpcUrl: string,
        chainId: number,
    },
    testMode?: boolean,
    deferPreload?: boolean,
    useStorageCache?: boolean,
}

export interface MagicOptions {
    overideApiKey?: string | undefined, 
    environment?: Environment,
    callerId?: string
}

export const MagicAPI = (_options: MagicOptions = {
    environment: Environment.PRODUCTION,
    overideApiKey: undefined
}): Magic => {
    const magicApiKey = _options.environment?.toLowerCase() === Environment.PRODUCTION.toLowerCase() 
        ? MAGIC_PROD_API 
        : MAGIC_STAGE_API 
    const magicConfig: MagicConfig = {
        network: {
            rpcUrl: 'https://polygon-rpc.com/',
            chainId: 137
        },
        useStorageCache: true,
        deferPreload: true,
    }   
    console.log('magicApiKey', magicApiKey)
    const magicApi = new Magic(
        magicApiKey,
        magicConfig
    )
    //magicApi.preload()
    return magicApi
}

